(function () {
  try {
    function initPageFlyCartListener() {
      if (!window.__pagefly_helper_store__) return;

      window.__pagefly_helper_store__.subscribe(function () {
        fetch('/cart.json')
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            // Update cart count
            var cartCountEl = document.getElementById('CartCount');
            if (cartCountEl) {
              cartCountEl.textContent = cart.item_count;
            }

            // Reload ajax cart if available
            if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
              window.ajaxCart.load();
            }

            // Open drawer slightly later to avoid layout shift
            if (window.timber && timber.RightDrawer) {
              setTimeout(function () {
                timber.RightDrawer.open();
              }, 150);
            }
          })
          .catch(function () {});
      });
    }

    // Run only when browser is idle (BEST for Lighthouse)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(initPageFlyCartListener, { timeout: 3000 });
    } else {
      // Fallback for Safari
      setTimeout(initPageFlyCartListener, 3000);
    }
  } catch (e) {
    console.warn(e);
  }
})();
